import { useTheme } from '@fluentui/react';
import React, { useState } from 'react';
import { Cell, LabelList, Pie, PieChart } from 'recharts';
import {
  Chart,
  ChartProps,
  currencyFormatter,
  useColors,
  useStyles,
} from '../common';
import { useHistory } from 'react-router-dom';
import { globalMode } from 'utility/cache/ui';
import clsx from 'clsx';
import { LocationsChartData } from './__generated__/LocationsChartData';

const RADIUS = 120;
const LABEL_OFFSET = 15;

import query from './LocationsChartData.graphql';
const Component: React.FC<ChartProps<LocationsChartData>> = ({
  data,
  height,
  width,
}) => {
  const styles = useStyles();
  const theme = useTheme();
  const colors = useColors();
  const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
  const [animation, setAnimation] = useState(true);
  const history = useHistory();

  return (
    <PieChart height={height} width={width}>
      <Pie
        data={data?.kpiBusinessUnits?.nodes}
        cx="50%"
        cy="50%"
        outerRadius={RADIUS}
        stroke={theme.palette.neutralLighterAlt}
        dataKey="amount"
        onMouseEnter={(_: any, index: number) => setActiveIndex(index)}
        onMouseLeave={(_: any, index: number) => {
          if (activeIndex === index) setActiveIndex(undefined);
        }}
        onClick={() => {
          if (activeIndex !== undefined) {
            globalMode(true);
            history.push(
              `signing?t=${data?.kpiBusinessUnits?.nodes[activeIndex].linkSearchValue}`
            );
          }
        }}
        className={clsx(activeIndex !== undefined && styles.pointer)}
        isAnimationActive={animation}
        onAnimationEnd={() => setAnimation(false)}
      >
        {data?.kpiBusinessUnits?.nodes.map((_entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={colors[index % colors.length][index === activeIndex ? 1 : 0]}
          />
        ))}
        <LabelList
          position="outside"
          fill={theme.palette.neutralPrimary}
          stroke="none"
          dataKey="title"
          offset={LABEL_OFFSET}
          width={(width - RADIUS * 2 - LABEL_OFFSET) / 2.0}
        />
        <LabelList
          position="inside"
          fill="white"
          stroke="none"
          dataKey="amount"
          formatter={(value: number) => currencyFormatter.format(value)}
          fontSize={12}
          pointerEvents="none"
        />
      </Pie>
    </PieChart>
  );
};

export const LocationsChart: Chart<LocationsChartData> = {
  Component,
  query,
  hasData: (data) => !!data.kpiBusinessUnits?.nodes.length,
};
